import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { EmbedSelectV2 } from "../components/EmbedSelectV2";
import { SearchPanel } from "../../../../components/Header/SearchPanel";
import { IconCross, IconPlus } from "../../../../utils/icons";
import { CreateNewStory } from "../../embeds/embedsV2/CreateNewStory";

interface Props {
  open: boolean;
  onClose: () => void;
  /** Fires only when membership actually changed (save or create-new-story). */
  onComplete?: () => void;
  brandId: string;
  videoId: number | null;
}

export function AddToStoryModalV2({ open, onClose, onComplete, brandId, videoId }: Props) {
  const [search, setSearch] = useState("");
  const [createStory, setCreateStory] = useState(false);
  const [shouldSubmit, setShouldSubmit] = useState(false);
  useEffect(() => {
    // Must not survive a close: EmbedSelectV2 remounts on reopen and would
    // submit instantly on mount with a stale true.
    if (!open) setShouldSubmit(false);
  }, [open]);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const dataProps = {
    search,
    shouldSubmit,
    videoId,
    onClose,
    onComplete,
    brandId: Number(brandId),
  };

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose} fullScreen={fullScreen}>
      <DialogTitle className="!border-b !border-border-token gap-6">
        <Box className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <Box className="flex items-center justify-between gap-2">
            <Typography variant="h5" className="whitespace-nowrap">
              Add video to story
            </Typography>
            <Box className="p-2 cursor-pointer sm:hidden" onClick={onClose}>
              <IconCross />
            </Box>
          </Box>
          <Box className="flex items-center gap-2 w-full sm:w-auto">
            <Box className="flex-1 sm:flex-none">
              <SearchPanel onSearchChange={setSearch} />
            </Box>
            <Box className="hidden sm:block p-2 cursor-pointer" onClick={onClose}>
              <IconCross />
            </Box>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent className="!p-0">
        <Box className="flex flex-col w-full py-6">
          <Box
            className="flex gap-4 mx-6 my-2 cursor-pointer pr-2 border-b w-fit border-transparent hover:border-accent"
            onClick={() => setCreateStory(true)}
          >
            <IconPlus stroke="#A58450" />
            <Typography variant="body1" className="!capitalize text-accent-text">
              Create new story
            </Typography>
          </Box>
          <EmbedSelectV2 {...dataProps} />
        </Box>
      </DialogContent>
      <DialogActions className="!p-4 border-t border-border-token">
        <Box className="flex w-full items-center justify-end">
          <Button
            size="large"
            variant="contained"
            onClick={() => setShouldSubmit(true)}
          >
            Save changes
          </Button>
        </Box>
      </DialogActions>
      {createStory && (
        <CreateNewStory
          selectedVideos={[videoId || 0]}
          refetchEmbeds={() => {
            onComplete?.();
            onClose();
          }}
          onClose={() => setCreateStory(false)}
        />
      )}
    </Dialog>
  );
}
